import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ContactPage from "../../pages/contactPage/contactPage";
import { routes } from "./routes";
import AboutUsPage from "../../pages/aboutUsPage/aboutUsPage";
import HomePage from "../../pages/homePage/homePage";
import EditionsPage from "../../pages/editionsPage/editionsPage";
import AdvertisementRequestPage from "../../pages/advertisementRequestPage/advertisementRequestPage";
import UpdateDataPage from "../../pages/updateDataPage/updateDataPage";
import AdvertisementPage from "../../pages/advertisementPage/advertisementPage";
import DigitalMarketingPage from "../../pages/digitalMarketingPage/digitalMarketingPage";

const AppRouter = () => {
  return (
    <Routes>
      <Route path={routes.home} element={<HomePage />} />
      <Route path={routes.contact} element={<ContactPage />} />
      <Route path={routes.about} element={<AboutUsPage />} />
      <Route path={routes.editions} element={<EditionsPage />} />
      <Route
        path={routes.advertisementRequest}
        element={<AdvertisementRequestPage />}
      />
      <Route path={routes.updateData} element={<UpdateDataPage />} />
      <Route path={routes.advertisement} element={<AdvertisementPage />} />
      <Route
        path={routes.digitalMarketing}
        element={<DigitalMarketingPage />}
      />
    </Routes>
  );
};

export default AppRouter;
